import { useState, useEffect } from 'react';
import { FinancialOverview } from '../types';
import { financialService } from '../services/financial';

export const useFinancialData = () => {
  const [overview, setOverview] = useState<FinancialOverview | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOverview = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await financialService.getOverview();

      if (response.success && response.data) {
        setOverview(response.data);
      } else {
        setError(response.error || 'Failed to fetch financial overview');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to fetch financial overview');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOverview();
  }, []);

  return {
    overview,
    isLoading,
    error,
    refetch: fetchOverview,
  };
};
